import { render, staticRenderFns } from "./HeartysanCategoryHead.vue?vue&type=template&id=5ec667b3&scoped=true"
import script from "./HeartysanCategoryHead.vue?vue&type=script&lang=js"
export * from "./HeartysanCategoryHead.vue?vue&type=script&lang=js"
import style0 from "./HeartysanCategoryHead.vue?vue&type=style&index=0&id=5ec667b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec667b3",
  null
  
)

export default component.exports